document.addEventListener("click", function (e) {

    const openBtn = e.target.closest("[data-sidebar]");
    const closeBtn = e.target.closest("[data-close-sidebar]");
    const sidebar = document.querySelector("[data-global-sidebar]");
    const body = document.body;

    // OPEN
    if (openBtn) {
        e.preventDefault();

        const type = openBtn.getAttribute("data-sidebar");

        const content = document.querySelector(`[data-content="${type}"]`);
        const title = openBtn.getAttribute("data-title") || '';

        document.getElementById("sidebar-content").innerHTML = content ? content.innerHTML : '';
        document.getElementById("sidebar-title").innerText = title;

        body.classList.add("global-sidebar-show");
        return;
    }

    // CLOSE BUTTON
    if (closeBtn) {
        body.classList.remove("global-sidebar-show");
        return;
    }

    // OUTSIDE CLICK
    if (body.classList.contains("global-sidebar-show")) {
        const clickedInside = sidebar && sidebar.contains(e.target);

        if (!clickedInside) {
            body.classList.remove("global-sidebar-show");
        }
    }

});
document.addEventListener("keydown", function(e){
    if(e.key === "Escape"){
        document.body.classList.remove("global-sidebar-show");
    }
});